import React from 'react';

import Notice from 'components/ui/Notice';
import { isArrayEmpty } from 'helpers/ArrayHelpers';
import { cx } from 'helpers/StylingHelpers';
import { useNotices } from 'hooks/data/useNotices';
import { useIsAuthenticated } from 'hooks/useIsAuthenticated';

import type {
  DataTestId, INotice, NoticePageType, NoticeSlotType
} from 'types';

import styles from './NoticeSlot.module.scss';

interface Props extends DataTestId {
  classNames?: {
    root?: string,
    notice?: string
  },
  page?: NoticePageType,
  slot?: NoticeSlotType
}

const NoticeSlot = (props: Props) => {

  const {
    classNames = {},
    page,
    slot,
    dataTestId
  } = props;

  // Hooks

  const {
    isFetching: isAuthenticationFetching,
    isSettled: isAuthenticationSettled,
    isAuthenticated
  } = useIsAuthenticated();

  const { data: notices } = useNotices({
    isPersonalized: isAuthenticated,
    page,
    slot
  }, {
    enabled: !isAuthenticationFetching && isAuthenticationSettled
  });

  // Empty

  if (isArrayEmpty(notices)) return null;

  // Render

  return (
    <div
      className={cx(styles.root, classNames.root)}
      data-testid={dataTestId}
    >
      {
        notices?.map((notice: INotice, index: number) => {
          return (
            <Notice
              key={`notice-${index}`}
              classNames={{
                root: cx(styles.notice, classNames.notice)
              }}
              notice={notice}
              withMarkdown
              dataTestId={dataTestId ? `${dataTestId}.notice` : ''}
            />
          );
        })
      }
    </div>
  );
};

export default NoticeSlot;
